<template>
	<div class="brick" style="height:900px;">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text">Item {{ headers.class }}</em>
				<span class="int_type_no_border mgr_5"> <ItemClassSelect v-model="itemClass" :showName="false" :codeWidth="100" @set-item-class="setSearchClass" /> </span>
				<em v-if="profile.use_size_code == 'Y'" class="lt_text">Color </em>
				<span v-if="profile.use_size_code == 'Y'" class="int_type_no_border mgr_5">
					<CodeSelect className="tbl_select sm_int" :width="100" :codeWidth="100" :showDesc="false" codeType="COL" :codes="colors" v-model="color_code" />
				</span>

				<span class="int_type mgr_15">
					<select v-model="closed_yn" class="tbl_select sm_int">
						<option v-for="tag in this.$closedTags" v-bind:value="tag.value" v-bind:key="tag.value">{{ tag.text }}</option>
					</select>
				</span>
				<span class="int_type mgr_15">
					<select v-model="active_yn" class="tbl_select sm_int">
						<option v-for="tag in this.$activeTags" v-bind:value="tag.value" v-bind:key="tag.value">{{ tag.text }}</option>
					</select>
				</span>
				<span class="int_type">
					<input type="text" v-model="keyword" placeholder="Keyword or Barcode" autofocus autocomplete="off" @keyup.enter="search()" />
				</span>
				<span class="int_type" style="width:60px;">
					<input type="text" v-model="rack" placeholder="Rack" autofocus autocomplete="off" @keyup.enter="search()" />
				</span>
				<span class="int_type mgr_15" style="width:60px;">
					<input type="text" v-model="section" placeholder="Section" autofocus autocomplete="off" @keyup.enter="search()" />
				</span>

				<em class="lt_text">On Hand</em>
				<span class="int_type">
					<select v-model="on_hand_condition" class="tbl_select sm_int">
						<option :value="null"></option>
						<option value="less_than">&lt;</option>
						<option value="equal">=</option>
						<option value="greater_than">&gt;</option>
					</select>
				</span>
				<span class="int_type mgr_15 " style="width:60px;">
					<currency-input type="text" class="al_right" :precision="0" v-model="on_hand_quantity" autocomplete="off" />
				</span>
				<a href="javascript:;" class="search_bt" @click="search()">Search</a>
				<a href="javascript:;" class="gray_bt" @click="reset()">Reset</a>
			</div>
		</div>

		<div class="half_tbl_box">
			<div class="left_big5_tbl">
				<div style="height: 740px; overflow-y: auto; overflow-x: hidden;">
					<table id="item_list" class="list_tbl tbl_pointer" v-columns-resizable>
						<thead>
							<tr>
								<th style="text-align:center;width:70px;">Item ID</th>
								<th style="text-align:center;width:210px;">Item Code</th>
								<th v-if="user.company_id != 'jc'" style="text-align:center;width:120px;">Color Code</th>
								<th v-if="user.company_id == 'he'" style="text-align:center;width:120px;">Color Name</th>
								<th v-if="profile.use_size_code == 'Y'" style="text-align:center;width:60px;">Size</th>
								<th style="text-align:center">Name</th>
								<th style="text-align:center;width:45px;">Pack</th>
								<th style="text-align:center;width:45px;">Unit</th>

								<th style="text-align:center;width:45px;">Loc.</th>
								<th style="text-align:center;width:45px;">Rack</th>
								<th style="text-align:center;width:45px;">Sec.</th>
								<th style="text-align:center;width:100px;">Barcode</th>

								<th style="text-align:center;width:65px;">On Hand</th>
							</tr>
						</thead>

						<tbody>
							<tr v-for="item in items" v-bind:key="item.item_id" v-bind:class="{ on: item.item_id == selectedItem.item_id }" @click="selectRow(item)">
								<td>{{ item.item_id }}</td>
								<td class="truncate" :title="item.item_code">{{ item.item_code }}</td>
								<td class="truncate" v-if="user.company_id != 'jc'">{{ item.color_code }}</td>
								<td v-if="user.company_id == 'he'">{{ item.color_name }}</td>
								<td v-if="profile.use_size_code == 'Y'">{{ item.size_code }}</td>
								<td class="truncate">{{ item.name }}</td>
								<td style="text-align:right;">{{ item.packing }}</td>
								<td>{{ item.unit_code }}</td>

								<td>{{ item.location_name }}</td>
								<td>{{ item.rack }}</td>
								<td>{{ item.section }}</td>
								<td>{{ item.barcode }}</td>

								<td style="text-align:right;">{{ item.on_hand | commaSeparated }}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div style="text-align:right;padding-top:5px;padding-right:10px;">Total Count : {{ list_count | commaSeparated }}</div>

				<Paging ref="paging" v-on:gotoPage="gotoPage"></Paging>

				<div class="view_bottom_bt">
					<span class="int_type_no_border mgr_15">
						<PageSizeSelect v-model="page_size" @input="search()" />
					</span>
					<a href="javascript:;" :class="selectedItem.item_id ? 'gray_bt' : 'disable_bt'" style="margin-right:15px" @click="viewDetail()">View Detail (Popup)</a>
					<a href="javascript:;" :class="selectedItem.item_id ? 'gray_bt' : 'disable_bt'" style="margin-right:15px" @click="repackHistory()">Repack History (Popup)</a>
					<a href="javascript:;" :class="selectedItem.item_id ? 'gray_bt' : 'disable_bt'" @click="inventoryHistory()">Inventory History</a>
				</div>
			</div>

			<div class="right_small5_tbl">
				<h4 class="inner_h5">
					Repacking
					<span class="int_type_no_border" style="font-weight:normal;margin-left:20px;">
						<ItemSelect v-model.trim="element_item_code_to_add" :active_only="true" :resultsDisplay="obj => obj.item_code + ' | ' + obj.name" />
					</span>
					<a v-if="modifiable" href="javascript:;" class="gray_bt " style="font-weight:normal;margin-left:5px;" @click="addElement()">Add</a>
				</h4>
				<div style="height: 197px; overflow-y: auto; overflow-x: hidden;">
					<table id="item_list" class="list_tbl tbl_pointer" v-columns-resizable border="0">
						<thead>
							<tr>
								<th style="text-align:center;width:160px;">Item Code</th>
								<th style="text-align:center;">Item Name</th>
								<th style="text-align:center;width:50px;">On Hand</th>
								<th style="text-align:center;width:70px;">Qty</th>
								<th style="text-align:center;width:40px;">Del</th>
							</tr>
						</thead>

						<tbody>
							<tr v-for="(element, index) in elements" v-bind:key="index">
								<td class="truncate" :title="element.item_code">{{ element.element_code }}</td>
								<td class="truncate">{{ element.element_name }}</td>
								<td style="text-align:right;">{{ element.element_on_hand | commaSeparated }}</td>
								<td><currency-input type="text" v-model="element.element_quantity" :precision="0" class="tbl_int sssm_int al_right" @focus="$event.target.select()" /></td>
								<a href="javascript:void(0);" class="gray_bt2" @click="delElement(element)">Del</a>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="view_bottom_bt" style="padding-top:5px;">
					<table class="view_tbl2" border="0">
						<colgroup>
							<col style="width: 35px;" />
							<col style="width: 70px;" />
							<col style="width: 75px;" />
							<col style="width: 100px;" />
							<col style="width: 45px;" />
							<col style="width: 120px;" />
							<col />
						</colgroup>
						<tbody>
							<tr>
								<td>Qty</td>
								<td class="al_left"><currency-input type="text" v-model="quantity_to_repack" :precision="0" class="tbl_int sssm_int al_right" @focus="$event.target.select()" /></td>
								<td>Exp Date</td>
								<td class="al_left"><CustomDatePicker v-model="exp_date_to_repack" /></td>
								<td>BIN</td>
								<td class="al_left"><input type="text" v-model="bin_to_repack" class="tbl_int full_int" @focus="$event.target.select()" /></td>
								<td><a v-if="modifiable" href="javascript:;" :class="selectedItem.item_id ? 'gray_bt' : 'disable_bt'" @click="repack()">Execute</a></td>
							</tr>
						</tbody>
					</table>
				</div>

				<h4 class="inner_h5" style="padding-top:20px;">
					Subdivision
					<span class="int_type_no_border" style="font-weight:normal;margin-left:20px;">
						<ItemSelect v-model.trim="child_item_code_to_add" :active_only="true" :resultsDisplay="obj => obj.item_code + ' | ' + obj.name" />
					</span>
					<a v-if="modifiable" href="javascript:;" class="gray_bt " style="font-weight:normal;margin-left:5px;" @click="addChild()">Add</a>
				</h4>
				<div style="height: 143px; overflow-y: auto; overflow-x: hidden;">
					<table id="item_list" class="list_tbl tbl_pointer" v-columns-resizable border="0">
						<thead>
							<tr>
								<th style="text-align:center;width:20px;"></th>
								<th style="text-align:center;width:160px;">Item Code</th>
								<th style="text-align:center;">Item Name</th>
								<th style="text-align:center;width:50px;">On Hand</th>
								<th style="text-align:center;width:70px;">Qty</th>
								<th style="text-align:center;width:40px;">Del</th>
							</tr>
						</thead>

						<tbody>
							<tr v-for="(child, index) in children" v-bind:key="index">
								<td><input type="checkbox" v-model="child.selected" /></td>
								<td class="truncate" :title="child.item_code">{{ child.child_code }}</td>
								<td class="truncate">{{ child.child_name }}</td>
								<td style="text-align:right;">{{ child.child_on_hand | commaSeparated }}</td>
								<td><currency-input type="text" v-model="child.child_quantity" :precision="0" class="tbl_int sssm_int al_right" @focus="$event.target.select()" /></td>
								<a href="javascript:void(0);" class="gray_bt2" @click="delChild(child)">Del</a>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="view_bottom_bt" style="padding-top:5px;">
					<table class="view_tbl2" border="0">
						<colgroup>
							<col style="width: 35px;" />
							<col style="width: 70px;" />
							<col style="width: 75px;" />
							<col style="width: 100px;" />
							<col style="width: 45px;" />
							<col style="width: 120px;" />
							<col />
						</colgroup>
						<tbody>
							<tr>
								<td>Qty</td>
								<td class="al_left"><currency-input type="text" v-model="quantity_to_subdivide" :precision="0" class="tbl_int sssm_int al_right" @focus="$event.target.select()" /></td>
								<td>Exp Date</td>
								<td class="al_left"><CustomDatePicker v-model="exp_date_to_subdivide" /></td>
								<td>BIN</td>
								<td class="al_left"><input type="text" v-model="bin_to_subdivide" class="tbl_int full_int" @focus="$event.target.select()" /></td>
								<td><a v-if="modifiable" href="javascript:;" :class="selectedItem.item_id ? 'gray_bt' : 'disable_bt'" @click="subdivide()">Execute</a></td>
							</tr>
						</tbody>
					</table>
				</div>

				<h4 class="inner_h5" style="padding-top:240px;"></h4>
				<div class="view_bottom_bt" style="margin-top:25px;">
					<a v-if="modifiable" href="javascript:;" class="search_bt" @click="submit()">Save Repacking / Subdivision Info</a>
				</div>
			</div>
		</div>

		<Modal @close="closeModal()" v-if="showModal && modalName == 'Lot'" :draggable="false" style="z-index:2000">
			<template slot="title">Inventory Detail</template>
			<template slot="body">
				<LotPopup @close="closeModal()" :item_id="selectedItem.item_id" />
			</template>
		</Modal>

		<Modal @close="closeModal()" v-if="showModal && modalName == 'RepackHistory'" :draggable="false" style="z-index:2000">
			<template slot="title">Repack History</template>
			<template slot="body">
				<RepackHistoryPopup @close="closeModal()" :item_id="selectedItem.item_id" />
			</template>
		</Modal>
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
import { apiIndex, apiSelectItemList } from '@/api/item/master.js';
import { apiSelectRepackList, apiSaveRepacks, apiRepack, apiSubdivide } from '@/api/item/inventory.js';

import { apiSelectItem } from '@/api/item/master.js';

import Paging from '@/components/common/Paging';
import PageSizeSelect from '@/components/common/PageSizeSelect';
import CodeSelect from '@/components/common/CodeSelect';
import ItemClassSelect from '@/components/common/ItemClassSelect';
import ItemSelect from '@/components/common/ItemSelect';

import LotPopup from '@/components/common/LotPopup';
import RepackHistoryPopup from '@/components/common/RepackHistoryPopup';
import Modal from '@/components/common/Modal';

import CustomDatePicker from '@/components/common/CustomDatePicker.vue';

export default {
	data: function() {
		return {
			uri: null,
			//itemClasses: [],
			colors: [],
			sizes: [],
			units: [],
			locations: [],

			backUri: '/',
			paging_yn: 'Y',
			page_size: 0,
			page_no: 1,
			list_count: 0,

			itemClass: null,

			keyword: '',
			rack: '',
			section: '',
			color_code: null,
			closed_yn: 'N',
			active_yn: 'Y',
			on_hand_condition: null,
			on_hand_quantity: 0,

			items: [],
			selectedItem: {},

			item: {},
			repacks: [],

			element_item_code_to_add: null,
			child_item_code_to_add: null,

			showModal: false,
			modalName: '',

			quantity_to_repack: null,
			exp_date_to_repack: null,
			bin_to_repack: null,

			quantity_to_subdivide: null,
			exp_date_to_subdivide: null,
			bin_to_subdivide: null,
		};
	},
	props: ['headers'],
	computed: {
		user: function() {
			return this.$session.get('user');
		},
		profile: function() {
			return this.$session.get('profile');
		},
		modifiable() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
		elements() {
			return this.repacks.filter(r => r.repack_type == 'R');
		},
		children() {
			return this.repacks.filter(r => r.repack_type == 'S');
		},
	},
	components: {
		Paging,
		PageSizeSelect,
		CodeSelect,
		ItemClassSelect,
		ItemSelect,

		LotPopup,
		RepackHistoryPopup,
		Modal,
		CustomDatePicker,
	},
	methods: {
		setSearchClass(ic) {
			//console.log(itemClass);
			this.itemClass = ic.code;
			this.search();
		},

		findItemIndex(repack_type, item_code) {
			for (var i = 0; i < this.repacks.length; i++) {
				if (repack_type == 'R' && this.repacks[i].repack_type == repack_type && this.repacks[i].element_code == item_code) return i;
				else if (repack_type == 'S' && this.repacks[i].repack_type == repack_type && this.repacks[i].child_code == item_code) return i;
			}
			return -1;
		},

		addElement() {
			if (!this.selectedItem.item_id) return;

			if (this.selectedItem.item_code == this.element_item_code_to_add) {
				this.$toast.error('Self repacking is not allowed.');
				return;
			}

			this.addRepackItem('R', this.element_item_code_to_add);
		},

		delElement(element) {
			const found_index = this.findItemIndex('R', element.element_code);
			if (found_index >= 0) {
				this.repacks.splice(found_index, 1);
			}
		},

		async repack() {
			if (!this.selectedItem.item_id) return;

			if (this.elements.length == 0) {
				this.$toast.error('No component item exists');
				return;
			}

			if (this.elements.filter(e => !(e.element_quantity > 0)).length > 0) {
				this.$toast.error('Item with invalid component quantity exists');
				return;
			}

			if (!(this.quantity_to_repack > 0)) {
				this.$toast.error('Invalid repacking quantity');
				return;
			}

			var param = {
				item_id: this.selectedItem.item_id,
				elements: this.elements,
				quantity_to_repack: this.quantity_to_repack,
				exp_date_to_repack: this.exp_date_to_repack,
				location_code: this.selectedItem.location_code,
				bin: this.bin_to_repack,
			};
			//console.log(param);

			const { data } = await apiRepack(param);

			if (data.result) {
				this.$toast.success('Repacked successfully');
				this.selectedItem.on_hand = data.on_hand;
				this.selectRepackList();
			} else {
				this.$toast.error(data.msg);
			}
		},

		addChild() {
			if (!this.selectedItem.item_id) return;

			if (this.selectedItem.item_code == this.child_item_code_to_add) {
				this.$toast.error('Self subdivision is not allowed.');
				return;
			}

			this.addRepackItem('S', this.child_item_code_to_add);
		},

		delChild(child) {
			const found_index = this.findItemIndex('S', child.child_code);
			if (found_index >= 0) {
				this.repacks.splice(found_index, 1);
			}
		},

		async subdivide() {
			if (!this.selectedItem.item_id) return;

			const selected_children = this.children.filter(c => c.selected);

			if (selected_children.length == 0) {
				this.$toast.error('No subdivision selected');
				return;
			}

			if (selected_children.filter(c => !(c.child_quantity > 0)).length > 0) {
				this.$toast.error('Item with invalid subdivision quantity exists');
				return;
			}

			if (!(this.quantity_to_subdivide > 0)) {
				this.$toast.error('Invalid subdivision quantity');
				return;
			}

			var param = {
				item_id: this.selectedItem.item_id,
				children: selected_children,
				quantity_to_repack: this.quantity_to_subdivide,
				exp_date_to_repack: this.exp_date_to_subdivide,
				location_code: this.selectedItem.location_code,
				bin: this.bin_to_subdivide,
			};
			const { data } = await apiSubdivide(param);

			if (data.result) {
				this.$toast.success('Subdivided successfully');
				this.selectedItem.on_hand = data.on_hand;
				this.selectRepackList();
			} else {
				this.$toast.error(data.msg);
			}
		},

		async addRepackItem(repack_type, item_code) {
			const idx = this.repacks.findIndex(r => r.repack_type == repack_type && ((repack_type == 'R' && r.element_code === item_code) || (repack_type == 'S' && r.child_code === item_code)));

			if (idx >= 0) {
				this.$toast.error('Already Included Item.');
				return;
			}

			const { data } = await apiSelectItem({
				item_code: item_code,
			});

			if (!data.item) {
				this.$toast.error('Item Not Found');
				return;
			}
			//console.log(data);
			if (data.item) {
				if (repack_type == 'R') this.repacks.push({ repack_type: repack_type, item_id: this.selectedItem.item_id, element_id: data.item.item_id, element_code: data.item.item_code, element_name: data.item.name, element_on_hand: data.item.on_hand });
				else if (repack_type == 'S') this.repacks.push({ repack_type: repack_type, item_id: this.selectedItem.item_id, child_id: data.item.item_id, child_code: data.item.item_code, child_name: data.item.name, child_on_hand: data.item.on_hand });
			}

			//console.log(this.items_str);

			//this.repacks.push({ repack_type: 'R', item_id: null });
		},

		viewDetail() {
			if (!this.selectedItem.item_id) return;

			this.showModal = true;
			this.modalName = 'Lot';
		},

		repackHistory() {
			if (!this.selectedItem.item_id) return;

			this.showModal = true;
			this.modalName = 'RepackHistory';
		},

		closeModal() {
			this.showModal = false;
		},

		inventoryHistory() {
			if (!this.selectedItem.item_id) return;

			let routeData = this.$router.resolve({ name: 'inventoryHistory', params: {}, query: { backUri: this.uri, item_id: this.selectedItem.item_id } });
			window.open(routeData.href, 'herp_inventory_history');
		},

		search() {
			this.page_no = 1;
			this.selectItems();
		},
		reset() {
			this.page_no = 1;
			this.active_yn = 'Y';
			this.keyword = '';
			this.color_code = null;
			this.rack = '';
			this.section = '';
			this.itemClass = null;

			this.search();
		},
		async selectItems(pageNo) {
			if (pageNo) this.page_no = pageNo;
			else this.page_no = 1;
			this.item = {};
			this.selectedItem = {};

			var param = {
				class_code: this.itemClass,
				color_code: this.color_code,
				keyword: this.keyword,
				rack: this.rack,
				section: this.section,

				paging_yn: this.paging_yn,
				page_size: this.page_size,
				page_no: this.page_no,
				start_index: this.page_size * (this.page_no - 1),

				closed_yn: this.closed_yn,
				active_yn: this.active_yn,

				on_hand_condition: this.on_hand_condition,
				on_hand_quantity: this.on_hand_quantity,

				repack: true,
			};

			const { data } = await apiSelectItemList(param);
			this.items = data.itemList;

			this.list_count = data.list_count;

			if (this.items.length == 1) {
				this.selectRow(this.items[0]);
			}

			this.$refs.paging.setPage(this.page_no, this.page_size, this.list_count);

			inputSelectOnClick();
			var uri = '/item/repack?dummy=1';
			if (this.itemClass) uri += '&class_code=' + this.itemClass;
			if (this.keyword) uri += '&keyword=' + this.keyword;
			if (this.page_no) uri += '&page_no=' + this.page_no;
			if (this.closed_yn) uri += '&closed_yn=' + this.closed_yn;
			if (this.active_yn) uri += '&active_yn=' + this.active_yn;

			this.uri = uri;
			window.history.pushState({}, null, uri);
		},
		async checkValidity() {
			return true;
		},
		async submit() {
			if (!this.selectedItem.item_id) return;

			const param = { item_id: this.selectedItem.item_id, repacks: this.repacks };
			//console.log(param);

			// const dummy = 1;
			// if (dummy) return;

			const { data } = await apiSaveRepacks(param);

			if (data.result) {
				this.$toast.success('Saved successfully');
				//this.selectedItem.on_hand = data.on_hand;
			} else {
				this.$toast.error(data.msg);
			}
		},
		gotoPage(pageNo) {
			//console.log('going to page', pageNo);
			//this.page_no = pageNo;
			this.selectItems(pageNo);
		},
		async selectRepackList() {
			const { data } = await apiSelectRepackList({
				paging_yn: 'N',
				item_id: this.selectedItem.item_id,
			});

			//console.log(data);

			this.repacks = data.repackList;

			this.quantity_to_repack = null;
			this.exp_date_to_repack = null;
			this.bin_to_repack = null;

			this.quantity_to_subdivide = null;
			this.exp_date_to_subdivide = null;
			this.bin_to_subdivide = null;
		},
		selectRow(item) {
			this.selectedItem = item;

			this.selectRepackList();
		},
		async index() {
			const { data } = await apiIndex();

			//this.itemClasses = data.itemClassList;
			this.colors = data.colorList;
			this.sizes = data.sizeList;
			this.units = data.unitList;
			this.locations = data.locationList;
			//console.log(this.itemClasses);

			//this.setDlOptions(this.dlClassGroup, data.classGroupList);
		},
		async init() {
			await this.index();
			//if (this.$route.query.item_id) this.item_id = this.$route.query.item_id;
			if (this.$route.query.class_code) this.class_code = this.$route.query.class_code;
			if (this.$route.query.keyword) this.keyword = this.$route.query.keyword;
			if (this.$route.query.page_no) this.page_no = this.$route.query.page_no;
			if (this.$route.query.closed_yn) this.closed_yn = this.$route.query.closed_yn;
			if (this.$route.query.active_yn) this.active_yn = this.$route.query.active_yn;
			this.page_size = this.$store.getters['getDefaultPageSize'];

			await this.selectItems(this.$route.query.page_no);
		},
	},
	created() {
		if (this.$route.query.backUri) this.backUri = this.$route.query.backUri;

		this.$store.commit('setSideIndex', 1);
		this.$store.commit('setSelectedMenu', 'nav_li_repack');
		this.$store.commit('setSubTitle', 'Item -> Repacking / Subdivision');

		this.init();
		// this.selectItems();
		inputSelectOnClick();
	},
	mounted() {
		this.$nextTick(function() {
			inputSelectOnClick();
			//makeTableResizable();
		});
	},
};
</script>

<style></style>
